<template>
  <div>111111111111
    <div style="margin: 0px 10px 0px 10px;">
      ceshi
    </div>
  </div>


</template>

<script>

export default {
  data () {
    return {

    };
  },
  mounted() {

  },
  methods: {

  },
  components: {
    // wxmy
  },
};
</script>
<style>

</style>
